export interface TuningsResponse {
  code?: number;
  data?: Data;
}

export interface Data {
  tunings?: Partial<Tunings>;
  orgInfo?: OrgInfo;
  services?: Services;
  remediation?: Remediation;
  widgetPageLang?: string;
  widgetL18nLang?: string;
  locales?: Locales;
}

export interface Locales {
  en?: En;
}

export interface En {
  widget?: Widget;
  skip_links?: SkipLinks;
}

export interface SkipLinks {
  open_accessibility_nav?: string;
  open_accessibility_menu?: string;
  skip?: string;
  enable_visually_impaired?: string;
  disable_visually_impaired?: string;
}

export interface Widget {
  hide_label?: string;
  show_label?: string;
  html_title?: string;
  text_icon_small?: string;
  text_icon_large?: string;
}

export interface OrgInfo {
  domain?: string;
  allows: string[];
  ssoPath?: string;
  ssoProtocol?: string;
}

export interface Remediation {
  strategy: string;
  consolidated: string;
  alt: Alt;
  vagueLinks: BrokenLinks;
  headings: BrokenLinks;
  forms: AriaEditor;
  moderator: AriaEditor;
  externalLinks: BrokenLinks;
  brokenLinks: BrokenLinks;
  identicalTargets: BrokenLinks;
  customFocus: BrokenLinks;
  perSiteRemediation: AriaEditor;
  ariaEditor: AriaEditor;
  complex: Complex;
  contrast: Contrast;
  emptyControls: AriaEditor;
  language: AriaEditor;
  pdf: Alt;
}

export interface Alt {
  enabled?: boolean;
  quotaExceeded?: boolean;
}

export interface AriaEditor {
  resources?: null | string;
  enabled?: boolean;
}

export interface BrokenLinks {
  enabled?: boolean;
}

export interface Complex {
  navigationMenu?: BrokenLinks;
  skipLinks?: SkipLinksClass;
}

export interface SkipLinksClass {
  enabled?: boolean;
  anchorSelector?: null;
}

export interface Contrast {
  enabled?: boolean;
  autofix?: boolean;
  path?: null;
}

export interface Services {
  siteId?: number;
  userId?: number;
  noManage?: boolean;
  noLogo?: boolean;
  CUSTOM_BRANDING?: CustomBranding;
  MODIFY_MENU?: ModifyMenu;
  WHITE_LABEL?: ModifyMenu;
  LIVE_TRANSLATIONS?: LiveTranslations;
  paidAi?: boolean;
}

export interface CustomBranding {
  is_enabled?: boolean;
  is_renewable?: boolean;
  custom_logo_image_path?: string;
  custom_logo_image_link?: null;
}

export interface LiveTranslations {
  is_enabled?: boolean;
  is_renewable?: boolean;
  auto_translation?: boolean;
  autoTranslation?: boolean;
  remainingChars?: number;
  translationAllowed?: boolean;
}

export interface WhiteLabel {
  is_enabled?: boolean;
  is_renewable?: boolean;
  hide_report?: boolean;
  hide_manage?: boolean;
  hide_logo?: boolean;
  hide_asterisk?: boolean;
  hide_donate?: boolean;
  accessibility_report?: boolean;
}

export interface ModifyMenu {
  is_enabled?: boolean;
  is_renewable?: boolean;
  trial_applicable?: boolean;
  features_pattern?: string;
  color_mode?: string;
  dictionary?: boolean;
  profiles?: boolean;
  two_columns_layout?: boolean;
  oversized?: boolean;
}

export enum WidgetLayout {
  Full = 'full',
  Mini = 'mini',
  Nano = 'nano',
  Headless = 'headless',
}

export interface Tunings {
  accessibility_link_enabled: string;
  accessibility_link_text: string;
  accessibility_url: string;
  site_name: string;
  widget_color: string;
  paidAi?: boolean;
  widget_color_gradient: string;
  widget_hidden_for_site: string;
  widget_hidden_for_mobile: boolean;
  widget_sounds: boolean;
  widget_icon_size: string;
  widget_icon_type: string;
  widget_language: string;
  widget_position: string;
  widget_position_mobile: string;
  widget_custom_trigger: string;
  widget_custom_trigger_enabled: boolean;
  host: string;
  widget_position_nudge?: string;
  widget_position_nudge_mobile?: string;
  widget_live_language_enabled?: boolean;
  widget_layout?: WidgetLayout;
  widget_lst_button_enabled: boolean;
  widget_lst_button_icon_type: string;
  widget_lst_button_type: string;
  widget_ga_enabled: boolean;
  widget_no_report: boolean;
}

export interface ElementSettingsItem {
  name: string;
  value: string;
}

export interface ElementSettings {
  global: boolean;
  items: ElementSettingsItem[];
  host: string;
}
